import React from 'react';

import { Svg } from '@lglp/components';

import styles from './Pin.module.scss';

const Pin: React.FC<PinProps> = (props) => {
  return (
    <Svg viewBox="0 0 14.499 17.501" {...props}>
      <g transform="translate(0.75 0.75)">
        <path
          className={styles.cls1}
          d="M17.5,8.046C17.5,13.137,11,17.5,11,17.5S4.5,13.137,4.5,8.046a6.5,6.5,0,1,1,13,0Z"
          transform="translate(-4.5 -1.5)"
        />
        <path
          className={styles.cls2}
          d="M17.833,12.682A2.166,2.166,0,1,1,15.666,10.5a2.174,2.174,0,0,1,2.166,2.182Z"
          transform="translate(-9.167 -6.137)"
        />
      </g>
    </Svg>
  );
};

type PinProps = {
  className?: string;
};

export default Pin;
